import PropTypes from 'prop-types';
import React from 'react';
import { components, contentfulModels } from '@glowforge/ui-common';
const { Button } = components;

function getString(strings, key, defaultValue) {
  return _.get(strings, key, defaultValue);
}
const { pageStringsPropType } = contentfulModels;

const Subscription = ({
  canManageSubscriptions,
  isManagePending,
  onManageSubscriptions,
  pageStrings,
  subscriptionManageLink
}) => {
  
  if (!canManageSubscriptions || !subscriptionManageLink || subscriptionManageLink.length == 0) {
    return null;
  }

  const handleUrl = (url) => {
    window.open(url, '_blank');
  };

  const onClick = (e) => {
    e.preventDefault();
    e.target.disabled = true;
    onManageSubscriptions(subscriptionManageLink, handleUrl);
  };

  const text = getString(
    pageStrings,
    'settings-purchase-history-subscriptions-link-text',
    'Manage Subscription');

  return (
    <div className='Subscription'>
      <h1 className='h2'>Glowforge Premium</h1>
      <div className='manageSubscriptionsLinkContainer'>
        <Button
          type='text'
          className='externalLink'
          onClick={onClick}
          disabled={isManagePending}>{text}</Button>
      </div>
    </div>
  );
}

Subscription.propTypes = {
  canManageSubscriptions: PropTypes.bool,
  isManagePending: PropTypes.bool,
  onManageSubscriptions: PropTypes.func.isRequired, // eslint-disable-line
  pageStrings: pageStringsPropType.isRequired,
  subscriptionManageLink: PropTypes.string,
};

Subscription.defaultProps = {
  subscriptionManageLink: '',
  canManageSubscriptions: false,
  isManagePending: false,
};

export default Subscription;


// WEBPACK FOOTER //
// ./app/components/settings/subscription.jsx